import { TFunction } from 'i18next';
import { FullProject, LoggedUser, User, projectStatusByCode } from 'entities';

interface CanCreateParams {
  project: FullProject;
  projectUsers: Record<string, User>;
  user: LoggedUser;
}

export const OTHER = 'OTHER';

export const issueTypes = {
  SAMPLING: {
    subTypes: [
      'REAL_REACH_VS_BIDS',
      'OVERSAMPLE',
      'RECRUITMENT_NOT_WORKING',
      'HIGH_DROPOUT_RATE',
      'BEST_EFFORTS',
      'DIFFICULT_TARGET',
      OTHER,
    ],
  },

  EXECUTION: {
    subTypes: [
      'CLIENT_ADDED_ANOTHER_PROVIDER',
      'NO_RESPONSE_FROM_CLIENT',
      'CLIENT_ERROR',
      'INCOMPLETE_MATERIAL',
      'EARLY_DELIVERY',
      'NEW_TASKS_AFTER_APPROVAL',
      'REQUIREMENTS_ADJUSTED_AFTER_APPROVAL',
      'NO_QUOTA_UPDATE_FROM_CLIENT',
      OTHER,
    ],
  },

  QUALITY: {
    subTypes: [
      'HIGH_NUMBER_OF_LOW_QUALITY_ANSWERS',
      'PROGRAMMING_MISTAKE_FOUND_IN_FIELD',
      'PROGRAMMING_MISTAKE_DURING_CREATION',
      'LACK_OF_INTERNAL_COMMUNICATION',
      'FIELDWORK_LAUNCHED_WITHOUT_STRATEGY',
      'ESTIMATED_TIME_INCOMPATIBLE_WITH_COMPLEXITY',
      OTHER,
    ],
  },
};

export const actions = [
  {
    id: 'REQUEST_CLIENT_TO_RELAX_QUOTA_FILTERS',
    getLabel: (t: TFunction) => t('REQUEST_CLIENT_TO_RELAX_QUOTA_FILTERS'),
  },
  { id: 'ADJUST_SAMPLE_STRATEGY', getLabel: (t: TFunction) => t('ADJUST_SAMPLE_STRATEGY') },
  { id: 'RECONTACT', getLabel: (t: TFunction) => t('RECONTACT') },
  { id: 'OVERSAMPLING', getLabel: (t: TFunction) => t('OVERSAMPLING') },
  { id: 'OVERQUOTA', getLabel: (t: TFunction) => t('OVERQUOTA') },
  { id: 'EXTRA_WORK_HOURS_NEEDED', getLabel: (t: TFunction) => t('EXTRA_WORK_HOURS_NEEDED') },
  { id: 'REQUEST_RECRUITMENT', getLabel: (t: TFunction) => t('REQUEST_RECRUITMENT') },
  { id: 'REQUEST_PANEL_PARTNER', getLabel: (t: TFunction) => t('REQUEST_PANEL_PARTNER') },
  { id: 'RENEGOTIATE_DEADLINES', getLabel: (t: TFunction) => t('RENEGOTIATE_DEADLINES') },
  {
    id: 'ALIGN_FEASIBILITY_WITH_CLIENT',
    getLabel: (t: TFunction) => t('ALIGN_FEASIBILITY_WITH_CLIENT'),
  },
  { id: 'REQUEST_HELP_FROM_SALES', getLabel: (t: TFunction) => t('REQUEST_HELP_FROM_SALES') },
  {
    id: 'REQUEST_HELP_FROM_EXECUTORS',
    getLabel: (t: TFunction) => t('REQUEST_HELP_FROM_EXECUTORS'),
  },
  { id: OTHER, getLabel: (t: TFunction) => t(OTHER) },
];

export function verifyIfCanCreateIssue({ project, projectUsers, user }: CanCreateParams): boolean {
  const canCreate =
    projectStatusByCode[project.status].canOpenIssue &&
    [
      !!projectUsers[user.id],
      !!Object.values(projectUsers).find(
        ({ team }) => user.team.id === team && user.type === 'LEADER',
      ),
    ].some(Boolean);

  return canCreate;
}
